// @ts-nocheck: converted from JS

import {
  tempEntityArrayToMap,
  GroupValidationIssue,
} from '@/components/Studies/Create/Steps/GroupsAndTreatments/GroupsAndTreatment.utils';
import { _isEmpty } from '@/littledash';
import React, { useMemo } from 'react';
import StudyGroupSetup from '../../../Settings/Steps/Groups/StudyGroupSetup';
import { GroupConfiguration } from './GroupConfiguration';
import { type DisplayedGroupMetadata } from '@/model/Metadata.model.ts';
import { useStudyCreateGroups } from '@/utils/studyCreation/useStudyCreate.tsx';
import { DraftFormData } from '@/model/Draft.model.ts';
import { CreateStudyAction } from '@/components/Studies/Create/Create.model';
import type { TreatmentGroup } from '@/model/TreatmentGroup.model';

/**
 *
 * @param props {groups: Array<Group>, treatments: Array<Treatment>, groupTreatments: Array<GroupTreatment>}
 * @returns {Array}
 * @constructor
 */
export const groupTreatmentEntityMap = (groups = [], treatments = [], groups_treatments = []) => {
  const treatmentsMap = tempEntityArrayToMap(treatments);
  const groupTreatmentsMap = new Map(
    groups_treatments.map(({ group, treatments }) => [
      group,
      treatments.map((treatmentId) => treatmentsMap.get(treatmentId)),
    ])
  );
  return groups.map((group) => ({
    ...group,
    treatments: groupTreatmentsMap.get(group.temp_id) ?? [],
  }));
};

interface GroupCreationProps {
  study: DraftFormData;
  dispatch: React.Dispatch<CreateStudyAction>;
  groupIssues: Map<string, GroupValidationIssue>;
  savedGroupData?: Array<DisplayedGroupMetadata>;
}

export const GroupCreation = ({ study, dispatch, groupIssues, savedGroupData }: GroupCreationProps) => {
  const { groups, treatments, groupsTreatments, updateStudyGroups } = useStudyCreateGroups();
  const groupsWithTreatmentData = useMemo(
    () => groupTreatmentEntityMap(groups, treatments, groupsTreatments),
    [groups, treatments, groupsTreatments]
  );

  const handleGroupConfigurationChange = (changedConfiguration: Partial<DraftFormData>) => {
    dispatch({
      type: 'updateStudy',
      data: { ...changedConfiguration },
    });
  };

  const handleGroupChange = (updatedGroups: Array<TreatmentGroup>) => {
    const updatedGroupsMap = tempEntityArrayToMap(updatedGroups);
    const updatedGroupTempIdList = Array.from(updatedGroupsMap.keys());

    const filteredGroupsTreatments = groupsTreatments.filter((groupTreatment) => {
      const groupKey = groupTreatment.group;
      return updatedGroupTempIdList.includes(groupKey);
    });

    updateStudyGroups({
      type: 'UPDATE_ALL',
      data: {
        groups: [...updatedGroupsMap.values()],
        treatments,
        groupsTreatments: filteredGroupsTreatments,
      },
    });
  };

  return (
    <>
      <div className={`ui-card mv4 ${_isEmpty(groups) ? 'pa4' : ''}`} style={{ minHeight: 190 }}>
        <StudyGroupSetup
          groups={groupsWithTreatmentData}
          onUpdateGroupData={handleGroupChange}
          addTempId={true}
          conflicts={groupIssues?.size ?? 0}
          savedGroupData={savedGroupData}
        />
      </div>
      <div className="ui-card mv4">
        <GroupConfiguration study={study} onChange={handleGroupConfigurationChange} />
      </div>
    </>
  );
};
